export const visibleDocuments = (state) => {
  const now = new Date();

  return state.library.filter((x) => {
    const start=x.validFrom.toDate() <= now;
    const finish=x.validTo? x.validTo.toDate()>=now:true;
    return start&&finish?true:false;
  });
};
